import utf8 from "utf8";

export const iHeartDefaultImg = "//i.iheart.com/v2/img/default";
/*
export interface MediaServerOp {
    name: "max" | "contain" | "fit" | "quality" | "gravity" | "format";
    params: {
        format: string;
        gravity: string;
        quality: number;
        height: number;
        width: number;
    };
}
export interface ImageOps {
    ops: MediaServerOp[];
}
*/

/*
 * pass in a url to see if it's a valid mediaserver url
 * if yes, that means ops can be applied
 * if no, means it's from some 3rd party resource and should not get ops or go through mediaserver
 */
export function canHaveOps(url: string) {
    const regex = new RegExp("/(i(-stg)?.iheart.com|iscale.iheart.com|mediaserver..*)/");
    return regex.test(url) && !url.includes("ops=");
}

export function getMediaServerUrl(host: string, bucket: string, id: string) {
    return `https://${host}/v3/re/${bucket}${id}`;
}

export interface ProcessImageProps {
    url: string | null | undefined;
    gravity: "north" | "center";
    quality: number;
    resize: "fit" | "contain";
    width: number;
    height: number;
}

export function getContestMediaServerUrl(host: string, url: string) {
    const encodedUrl =
        typeof btoa !== "undefined" ? btoa(utf8.encode(url)) : Buffer.from(utf8.encode(url)).toString("base64");
    return `https://${host}/v3/url/${encodedUrl}`;
}

export const placeholderImage = "https://i.iheart.com/v3/re/new_assets/f79fc341-a979-4863-81b0-eea1ddc6e07b";
